<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <path fill="currentColor" d="m8 8-8 8V0z" />
</svg>
